import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants, Mimetype, UploadMediaAction } from '../../common';
import { BaseAPI } from './base-api';
import { Mapper } from '../mapper';
import { SignedMediaURL } from '../model';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MediaApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getUploadImageSignedURL(file: File): Observable<SignedMediaURL> {
    const body = {
      uploadAction: UploadMediaAction.IMAGE,
      contentType: file.type,
    };
    return this.baseAPI.post(Constants.SIGNED_UPLOAD_MEDIA_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromJson(SignedMediaURL, res);
      })
    );
  }

  getUploadFileSignedURL(file: File): Observable<SignedMediaURL> {
    const body = {
      uploadAction: UploadMediaAction.CALL_SHARED_FILE,
      contentType: file.type,
    };

    return this.baseAPI.post(Constants.SIGNED_UPLOAD_FILE_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromJson(SignedMediaURL, res);
      })
    );
  }

  uploadMediaURL(uploadUrl: string, file: File): Observable<unknown> {
    const headers = new HttpHeaders({ 'Content-Type': file.type });
    return this.baseAPI.put(uploadUrl, file, { headers });
  }
}
